<template>
  <v-container>
    <app-navigation></app-navigation>
    <v-main class="pt-12">
      <div class="pt-md-5">
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <main-sub-page-toolbar icon="mdi-clipboard-text-outline">{{
              getImageDatabaseName($route.params.type, true)
            }}</main-sub-page-toolbar>
          </v-flex>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <div>
              <data-table-search-toolbar
                :search.sync="search"
              ></data-table-search-toolbar>
              <v-data-table
                :loading-text="$t('lmPleaseWait')"
                class="#505050--text"
                :class="
                  getTheme() == 'dark'
                    ? 'outlined elevation-0'
                    : 'flat elevation-0'
                "
                :style="
                  getTheme() == 'dark'
                    ? 'border: 1px solid darkgray; border-top: none; background-color: white'
                    : 'border: none; background-color: white'
                "
                :headers="headers"
                :items="
                  $store.state.storeImageDatabaseCategory.imageDatabaseCategory
                "
                :search="search"
                sort-by="title"
                :items-per-page="-1"
                must-sort
                :no-results-text="$t('dataGridSlotNoResults')"
                :no-data-text="$t('dataGridSlotNoData')"
                :footer-props="{
                  itemsPerPageText: $t('dataGridRowsPerPageText'),
                  itemsPerPageAllText: $t('dataGridRowsPerPageAllText'),
                }"
              >
                <template v-slot:item.active="{ item }">
                  <v-icon :color="item.active ? 'success' : 'error'">{{
                    item.active
                      ? "mdi-check-circle-outline"
                      : "mdi-close-circle-outline"
                  }}</v-icon>
                </template>
                <template v-slot:item.actions="{ item }">
                  <div
                    v-if="
                      $store.state.storeAuth.userProfile.isSuperStoreAdmin ||
                      item.client ==
                        $store.state.storeClient.client.basicSettings.name
                    "
                    class="d-flex flex-no-wrap"
                  >
                    <v-icon class="mr-3" @click="editItem(item)"
                      >mdi-pencil</v-icon
                    >
                    <v-icon @click="deleteItemSet(item.id)">mdi-delete</v-icon>
                  </div>
                </template>
              </v-data-table>
            </div>
            <!-- DELETE CONFIRM DIALOG -->
            <dialog-basic-yes-no
              :active="dialogDelete"
              @clickYes="deleteItem"
              @clickNo="dialogDelete = false"
              icon="mdi-comment-question-outline"
              :title="$t('msgQuestion')"
              >{{ $t("deleteDialogQuestionWarning") }}
              {{ $t("deleteDialogQuestion") }}</dialog-basic-yes-no
            >
          </v-flex>

          <!-- PLEASE WAIT DIALOG -->
          <v-dialog
            v-model="dialogWait"
            persistent
            max-width="400"
            transition="dialog-bottom-transition"
          >
            <v-card>
              <v-card-title class="headline">{{
                $t("userNewOrderPleaseWaitTitle")
              }}</v-card-title>
              <v-card-text class="d-flex">
                <v-spacer></v-spacer>
                <v-progress-linear
                  color="primary"
                  height="10"
                  indeterminate
                ></v-progress-linear>
                <v-spacer></v-spacer>
              </v-card-text>
            </v-card>
          </v-dialog>

          <simple-navigation-button
            left
            :title="$t('lmBtnBack')"
            icon="mdi-arrow-left"
            @clicked="$router.push({ name: 'settingsSubMenuImageDatabase' })"
          ></simple-navigation-button>
          <!-- ADD / EDIT DIALOG -->
          <v-dialog
            v-model="dialog"
            max-width="500px"
            persistent
            transition="dialog-bottom-transition"
          >
            <template v-slot:activator="{ on }">
              <v-btn color="primary" v-on="on" dark fixed bottom right rounded>
                <v-icon medium class="mr-1">mdi-plus</v-icon>
                {{ $t("lmBtnAdd") }}
              </v-btn>
            </template>
            <v-form ref="form" v-model="valid">
              <v-card
                :class="
                  getTheme() == 'dark'
                    ? 'outlined elevation-0'
                    : 'flat elevation-0'
                "
                :style="
                  getTheme() == 'dark'
                    ? ''
                    : 'border-bottom: 1px solid lightgray'
                "
              >
                <v-card-title
                  :style="
                    getTheme() == 'dark'
                      ? 'background-color: #505050'
                      : 'background-color: white; border-bottom: 1px solid lightgray'
                  "
                  :class="
                    getTheme() == 'dark' ? 'white--text' : '#505050--text'
                  "
                  class="title font-weight-regular"
                >
                  <v-icon
                    :class="
                      getTheme() == 'dark' ? 'white--text' : 'primary--text'
                    "
                    class="mr-3"
                    medium
                    >{{
                      this.editedIndex == -1 ? "mdi-plus" : "mdi-pencil"
                    }}</v-icon
                  >
                  {{ formTitle }}
                </v-card-title>
                <v-card-text class="py-0 pt-2">
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-text-field
                          dense
                          v-model="editedItem.order"
                          type="number"
                          :label="$t('settingsImageDatabaseCategoryOrderTitle')"
                          :rules="[validateRequired(), validateIsNumber()]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex
                        v-show="
                          $store.state.storeAuth.userProfile.isSuperStoreAdmin
                        "
                        xs12
                      >
                        <v-select
                          item-text="client"
                          item-value="client"
                          :items="[
                            { client: '/' },
                            {
                              client:
                                $store.state.storeClient.client.basicSettings
                                  .name,
                            },
                          ]"
                          v-model="editedItem.client"
                          :label="$t('settingsImageDatabaseCategoryOwnerTitle')"
                          dense
                        ></v-select>
                      </v-flex>
                      <!--<v-flex xs12> 
                        <v-select
                          v-model="editedItem.module"
                          :items="moduleItems"
                          item-text="name"
                          item-value="module"
                          deletable-chips
                          small-chips
                          attach
                          chips
                          :label="
                            $t('settingsImageDatabaseCategoryModuleTitle')
                          "
                          multiple
                          dense
                        ></v-select>
                      </v-flex>-->
                      <v-flex xs12>
                        <v-text-field
                          dense
                          v-model="editedItem.title"
                          :label="$t('settingsImageDatabaseCategoryNameTitle')"
                          :rules="[validateRequired(), validateMaxLength(50)]"
                          :counter="50"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-switch
                          dense
                          style="height: 30px"
                          class="ma-0 pa-0"
                          v-model="editedItem.active"
                          :label="$t('settingsPhotoGiftCategoryActiveTitle')"
                        ></v-switch>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions
                  :class="
                    getTheme() == 'dark' ? '#505050--text' : '#505050--text'
                  "
                  :style="
                    getTheme() == 'dark'
                      ? 'background-color: whitesmoke; border-top: 1px solid lightgray;'
                      : 'background-color: white; border-top: 1px solid lightgray;'
                  "
                >
                  <v-spacer></v-spacer>
                  <v-btn color="primary" class="my-1" text @click="close()">{{
                    $t("addEditFormCancelButton")
                  }}</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn @click="save" color="primary" dark>
                    <v-icon medium class="mr-1">mdi-content-save</v-icon>
                    {{ $t("addEditFormSaveButton") }}
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-dialog>
          <v-snackbar
            v-model="$store.state.storeSnackbar.snackbar.active"
            :color="$store.state.storeSnackbar.snackbar.color"
            :timeout="$store.state.storeSnackbar.snackbar.timeout"
            >{{ $store.state.storeSnackbar.snackbar.message }}</v-snackbar
          >
        </v-layout>
      </div>
    </v-main>
  </v-container>
</template>

<script>
import AppNavigation from "@/views/AppNavigation";
import MainSubPageToolbar from "@/components/MainSubPageToolbar";
import DialogBasicYesNo from "@/components/DialogBasicYesNo";
import SimpleNavigationButton from "@/components/SimpleNavigationButton";
import DataTableSearchToolbar from "@/components/DataTableSearchToolbar";

export default {
  name: "settingsImageDatabaseCategory",
  components: {
    AppNavigation,
    MainSubPageToolbar,
    DialogBasicYesNo,
    SimpleNavigationButton,
    DataTableSearchToolbar,
  },
  data() {
    return {
      valid: true,
      netBackImage: require("@/assets/netBack.png"),
      defaultImage: require("@/assets/giftCategoryDefault.jpg"),
      search: "",
      dialog: false,
      dialogDelete: false,
      dialogDeleteId: "",
      dialogWait: false,
      headers: [
        {
          text: this.$t("settingsImageDatabaseCategoryOrderTitle"),
          align: "center",
          value: "order",
          sortable: true,
        },
        {
          text: this.$t("settingsImageDatabaseCategoryNameTitle"),
          align: "center",
          value: "title",
          sortable: true,
        },
        {
          text: this.$t("settingsImageDatabaseCategoryOwnerTitle"),
          align: "center",
          value: "client",
          sortable: true,
        },
        {
          text: this.$t("settingsImageDatabaseCategoryActiveTitle"),
          align: "center",
          value: "active",
          sortable: true,
        },
        {
          text: "",
          align: "center",
          sortable: false,
          value: "actions",
        },
      ],
      editedIndex: -1,
      editedItemOldTitle: "",
      editedItem: {
        order: 1,
        title: "",
        client: this.$store.state.storeClient.client.basicSettings.name,
        active: true,
      },
      defaultItem: {
        order: 1,
        title: "",
        client: this.$store.state.storeClient.client.basicSettings.name,
        active: true,
      },
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("addEditFormAddingTitle")
        : this.$t("addEditFormEditingTitle");
    },
  },
  methods: {
    deleteItemSet(item) {
      this.dialogDelete = true;
      this.dialogDeleteId = item;
    },
    async deleteItem() {
      try {
        await this.$store.dispatch(
          "removeImageDatabaseCategory",
          this.dialogDeleteId
        );
        this.dialogDelete = false;
        this.dialogDeleteId = "";

        this.$store.commit({
          type: "showSnackbar",
          color: "success",
          message: this.$t("msgSuccessDelete"),
        });
      } catch (error) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error,
        });
        return;
      }
    },
    editItem(item) {
      this.editedIndex =
        this.$store.state.storeImageDatabaseCategory.imageDatabaseCategory.indexOf(
          item
        );
      this.editedItem = Object.assign({}, item);
      this.editedItemOldTitle = item.title;
      this.dialog = true;
    },
    close() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
      this.dialog = false;
    },
    async save() {
      // ali kategorija s tem imenom že obstaja?
      let unique = true;
      this.$store.state.storeImageDatabaseCategory.imageDatabaseCategory.forEach(
        (x) => {
          console.log(x.title);
          if (
            x.title == this.editedItem.title &&
            this.editedItem.title != this.editedItemOldTitle
          )
            unique = false;
        }
      );
      if (unique) {
        if (this.$refs.form.validate()) {
          this.dialog = false;
          this.dialogWait = true;
          if (this.editedIndex > -1) {
            try {
              await this.$store.dispatch(
                "editImageDatabaseCategory",
                Object.assign(this.editedItem, {
                  type: this.$route.params.type,
                })
              );
              this.dialogWait = false;

              this.$store.commit({
                type: "showSnackbar",
                color: "success",
                message: this.$t("msgSuccessEdit"),
              });
            } catch (error) {
              this.$store.commit({
                type: "showSnackbar",
                color: "error",
                message: error,
              });
            }
          } else {
            try {
              await this.$store.dispatch(
                "addImageDatabaseCategory",
                Object.assign(this.editedItem, {
                  type: this.$route.params.type,
                })
              );

              this.dialogWait = false;

              this.$store.commit({
                type: "showSnackbar",
                color: "success",
                message: this.$t("msgSuccessAdd"),
              });
            } catch (error) {
              this.$store.commit({
                type: "showSnackbar",
                color: "error",
                message: error,
              });
            }
          }
          this.close();
        }
      } else {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: this.$t("settingsImageDatabaseDuplicateNameError"),
        });
      }
    },
  },
  created() {
    this.$store.dispatch("getImageDatabaseCategory", {
      type: this.$route.params.type,
      client: this.$store.state.storeClient.client.basicSettings.name,
      mode: "edit",
    });
  },
};
</script>